export default "__VITE_ASSET__CgRaNIc3__"